import { render } from "./OpsiMakanModal_c.vue?vue&type=template&id=40b473b6&scoped=true"
import script from "./OpsiMakanModal_c.vue?vue&type=script&lang=js"
export * from "./OpsiMakanModal_c.vue?vue&type=script&lang=js"

import "./OpsiMakanModal_c.vue?vue&type=style&index=0&id=40b473b6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-40b473b6"

export default script